const API_KEY = 'AIzaSyADwxhjx3exlfbBOK5FVhKgvboRI81f1_Q';
export const YT_VIDEO_API =
  'https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US&key=' +
  API_KEY;
